// Vendors
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogActions, Typography, Button, TextField } from '@mui/material';

// Components
import FormattedMessage from '@molecules/FormattedMessage';

// Assets
import closeIcon from '@assets/icons/close.svg';
import Loader from '../Loader';

const isValidEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

interface SendMailPopupProps {
  isOpen: boolean;
  onClose: () => void;
  // heading: string;
  label: string;
  prefilledEmail?: string;
  sendEmail: (email: string) => void;
  errorMessage?: string;
  email: string;
  setEmail: (value: string) => void;
  isLoading: boolean;
  containerClassname?: string;
}

const SendMailPopup: React.FC<SendMailPopupProps> = ({
  isOpen,
  onClose,
  // heading,
  label,
  sendEmail,
  errorMessage,
  email,
  setEmail,
  isLoading,
  containerClassname = '',
}) => {
  const [error, setError] = useState('');

  const validateEmail = (email: string): string => {
    if (!email) return 'Please enter an email address.';
    if (!isValidEmail(email)) return 'Please enter a valid email address.';
    return '';
  };

  const handleSend = () => {
    const validationError = validateEmail(email);
    if (validationError) {
      setError(validationError);
      return;
    }
    setError('');
    sendEmail(email);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    const validationError = validateEmail(newEmail);
    setError(validationError);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className={`email-popup-container ${containerClassname}`}
    >
      <Loader display={isLoading} />
      <DialogContent>
        <div className="close-container">
          <Typography className="heading">
            <FormattedMessage id="EMAIL_UPDATE.HEADER" />
          </Typography>
          <img src={closeIcon} alt="close-icon" className="close-icon" onClick={onClose} />
        </div>
        <Typography className="title">{label}</Typography>
        <Typography className="label-name">
          <FormattedMessage id="EMAIL_UPDATE.FORM_LABEL.EMAIL" />
        </Typography>
        <TextField
          id="email"
          name="email"
          value={email}
          onChange={handleChange}
          error={Boolean(error)}
          helperText={error}
          fullWidth
          className={`offer-outlined-text-field ${error ? 'form-field-error' : ''}`}
        />
      </DialogContent>
      {errorMessage && <div className="error">{errorMessage}</div>}
      <DialogActions className="email-btn-container">
        <Button onClick={onClose} className="cancel-btn">
          <FormattedMessage id="EMAIL_UPDATE.BUTTON.CANCEL" />
        </Button>
        <Button onClick={handleSend} className="send-btn">
          <FormattedMessage id="EMAIL_UPDATE.BUTTON.SEND" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendMailPopup;
